import { useState, useEffect, useCallback } from 'react';
import { api } from '../../lib/api';
import { useSSE } from '../../hooks/useSSE';
import { toast } from 'sonner';

export function useBadgeCounts(isAuthenticated) {
  const [notifCount, setNotifCount] = useState(0);
  const [inboxCount, setInboxCount] = useState(0);

  const refreshBadges = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const [notifRes, inboxRes] = await Promise.all([
        api.getUnreadCount(),
        api.getInboxUnreadCount().catch(() => ({ data: { unread_count: 0 } })),
      ]);
      setNotifCount(notifRes.data.count);
      setInboxCount(inboxRes.data?.unread_count || 0);
    } catch {
      setNotifCount(0);
      setInboxCount(0);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;
    refreshBadges();
    const interval = setInterval(refreshBadges, 30000);
    const handler = () => refreshBadges();
    window.addEventListener('refreshBadges', handler);
    return () => { clearInterval(interval); window.removeEventListener('refreshBadges', handler); };
  }, [isAuthenticated, refreshBadges]);

  useSSE(useCallback((event) => {
    if (event.type === 'notification') {
      setNotifCount(c => c + 1);
      toast(event.title, { description: event.message });
    }
    if (event.type === 'new_message' || event.type === 'new_quote') {
      api.getInboxUnreadCount().then(r => setInboxCount(r.data?.unread_count || 0)).catch(() => {});
    }
    if (event.type === 'badge_update') {
      if (event.notif_count !== undefined) setNotifCount(event.notif_count);
      if (event.inbox_count !== undefined) setInboxCount(event.inbox_count);
    }
  }, []));

  return { notifCount, inboxCount };
}
